/**
 * Presenter feature gating:
 * - Default is ON - Presenter Mode provides the best experience for live quiz presentations
 * - Hosts can toggle it per-quiz if they prefer self-paced mode
 */
export const buildPresenterDefault = true;

export function presenterEnabledAtStartup(): boolean {
  // Always return true - Presenter Mode is now the default experience
  return buildPresenterDefault;
}

